export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11880.08d20e2d.jpg";